export default class InplayConstants {}

InplayConstants.ALL_SPORTS_CODE = 'ALL';
InplayConstants.STREAMING = 'streaming';
